import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { Department } from '@/interfaces/model/general/department';
import { Role } from '@/interfaces/api/general/user';
import { RoleId } from '@/lib/enum';
import { formatPhoneNumber, parsePhone } from '@/lib/formatter';
import { required, phoneNumber, isPositionName, hasNoComma } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { usePermissionComposable } from '@/composables/usePermission';
import DepartmentTreeSelect from '@/components/DepartmentTreeSelect.vue';
import { DepartmentTreeNode } from '@/interfaces/model/general/department';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileEditForm',
  props: {
    firstName: null,
    lastName: null,
    middleName: null,
    email: null,
    phone: null,
    isSubscribe: { type: Boolean },
    isChecklistNotifySubscribe: { type: Boolean },
    departments: null,
    position: null,
    role: null,
    selectableDepartments: null,
    departmentTree: null,
    editableDepartmentTree: null,
    companyName: null
  },
  emits: ["update:isValidForm", "update:firstName", "update:lastName", "update:middleName", "update:phone", "update:isSubscribe", "update:isChecklistNotifySubscribe", "update:departments", "update:position"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:firstName', data: string): void;
  (e: 'update:lastName', data: string): void;
  (e: 'update:middleName', data: string): void;
  (e: 'update:phone', data: string): void;
  (e: 'update:isSubscribe', data: boolean): void;
  (e: 'update:isChecklistNotifySubscribe', data: boolean): void;
  (e: 'update:departments', data: Department[]): void;
  (e: 'update:position', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  phone: string;
  isSubscribe: boolean;
  isChecklistNotifySubscribe: boolean;
  departments: Department[];
  position: string;
  role: Role;
  selectableDepartments: Department[];
  departmentTree: DepartmentTreeNode[];
  editableDepartmentTree: DepartmentTreeNode[];
  companyName: string;
};

const m = defineMessages({
  changeEmailSupport: 'メールアドレスの変更はサポートにお問い合わせください',
  // SE-572 UX指摘③ チェックリスト更新通知メールの?アイコン ツールチップ。
  // NOTE(SE-572): 通知対象は「新規該当(new)」と「該当理由の変化(cause)」。
  // 「該当解除(removed)」は現在通知対象外のため文言に含めていない。
  // 将来 removed を通知するようになったら「・該当から外れたSDS」を追加すること
  //   （3項目版:「…新たに該当したSDS・該当理由が変わったSDS・該当から外れたSDSがあったとき…」）。
  checklistNotifyTooltip:
    'このメールは、お気に入りのチェックリストで新たに該当したSDS・該当理由が変わったSDSがあったときに、その分をまとめてお知らせします（送信は平日1日1回まで）。詳しくは「ヘルプセンター」をご確認ください。',
});



const { COMPANY_FEATURES, isFeatureActive } = useCompanyFeatureComposable();
const isSamlLoginEnabled = computed(() =>
  isFeatureActive(COMPANY_FEATURES.MANAGE_SAML_AUTHENTICATION)
);

const { hasPermission, PERMISSIONS } = usePermissionComposable();
const canEditDepartments = computed(() =>
  hasPermission(PERMISSIONS.DEPARTMENT_EDIT)
);
const canEditOtherDepartments = computed(() =>
  hasPermission(PERMISSIONS.DEPARTMENT_EDIT_OTHER_DEPARTMENT)
);
const selectableDepartmentTree = computed(() =>
  canEditOtherDepartments.value
    ? props.departmentTree
    : props.editableDepartmentTree
);

const isValidForm = ref<boolean>(false);



const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateFirstName = (e: string) => {
  emits('update:firstName', e);
};

const updateLastName = (e: string) => {
  emits('update:lastName', e);
};

const updateMiddleName = (e: string) => {
  emits('update:middleName', e);
};

const updatePhone = (e: string) => {
  emits('update:phone', e);
};

const updateIsSubscribe = (e: string) => {
  emits('update:isSubscribe', e === 'subscribe');
};

const updateIsChecklistNotify = (e: string) => {
  emits('update:isChecklistNotifySubscribe', e === 'subscribe');
};

const updateSelectedDepartments = (uuids: string[]) => {
  const selected = uuids
    .map((uuid) => props.selectableDepartments.find((d) => d.uuid === uuid))
    .filter((d): d is Department => d !== undefined);
  emits('update:departments', selected);
};

const updatePosition = (e: string) => {
  emits('update:position', e);
};

return { __sfc: true,m, props, COMPANY_FEATURES, isFeatureActive, isSamlLoginEnabled, hasPermission, PERMISSIONS, canEditDepartments, canEditOtherDepartments, selectableDepartmentTree, isValidForm, emits, updateIsValidForm, updateFirstName, updateLastName, updateMiddleName, updatePhone, updateIsSubscribe, updateIsChecklistNotify, updateSelectedDepartments, updatePosition, RoleId, formatPhoneNumber, parsePhone, required, phoneNumber, isPositionName, hasNoComma, sharedMessages, DepartmentTreeSelect }
}

})